import { Circle } from '@mui/icons-material';
import { Button } from '@mui/material';
import { forwardRef } from 'react';
import { FormattedDate } from 'react-intl';
import type { EventDto } from 'api/generated';
import { GetColorByAvailability } from 'lib/helpers/availability-color';
interface CalendarEventButtonProps {
  event: EventDto;
  onClick?: () => void;
  href?: string;
  size?: 'small' | 'medium' | 'large';
}
export const CalendarEventButton = forwardRef<HTMLAnchorElement, CalendarEventButtonProps>(function CalendarEventButton({
  event,
  onClick,
  href,
  size
}, ref) {
  const eventDisabled = event.saleStatus === 'Cancelled' || event.saleStatus === 'SoldOut' || event.isFree === true;
  return <Button component="a" variant={eventDisabled ? 'contained' : 'outlined'} color="monochrome" sx={{
    marginTop: 1,
    paddingLeft: 2,
    '> span': {
      position: 'absolute',
      left: 8
    }
  }} size={size ?? 'small'} startIcon={<Circle sx={{
    height: '10px',
    color: GetColorByAvailability(event)
  }} />} disabled={eventDisabled} href={href} onClick={onClick} ref={ref}>
      <FormattedDate value={event.startDate} hour="2-digit" minute="2-digit" />
    </Button>;
});